<section>
    <div id="desktop-banners"
         class="relative w-full min-h-[750px] hidden lg:block overflow-hidden aarni-font mt-[80px]"
         [ngStyle]="{ height: bannerHeight }">
        <img
            *ngFor="let image of images; let i = index"
            [src]="image"
            [ngClass]="{
        'opacity-100': currentIndex === i,
        hidden: currentIndex !== i
      }"
            class=" w-full h-full transition-opacity duration-1000 ease-in-out" loading="lazy"
        />

        <div
            class="absolute top-55 transform -translate-y-1/2 right-0 mr-24 bg-white shadow-lg p-6 md:p-8 w-full max-w-md z-10 rounded-2xl">
            <div>
                <div *ngIf="formSubmitted"
                     class="bg-green-500 text-white p-3 rounded mb-4 text-center font-semibold shadow">
                    ✅ Your form has been submitted successfully!
                </div>
                <h3 class="text-lg font-bold mb-4 text-center text-green-600 animate-blink">Admissions Open For
                    2025</h3>
                <form [formGroup]="applyNowForm">
                    <input
                        type="text"
                        placeholder="Name *"
                        class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        formControlName="name"
                    />
                    <input
                        type="email"
                        placeholder="Email *"
                        class="w-full border p-2 mb-2 rounded bg-gray-100 text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
                        formControlName="email"
                    />
                    <input
                        type="tel"
                        placeholder="Contact *"
                        class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        formControlName="contact"
                    />
                    <select
                        class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
                        formControlName="program_id"
                        (change)="getCourses()"
                    >
                        <option value="">Select Program</option>
                        <option *ngFor="let program of programs" [value]="program?.program?.id">
                            {{ program?.program?.name }}
                        </option>
                    </select>

                    <div class="relative">
                        <input
                            type="text"
                            (keyup)="filterCourses($event.target.value)"
                            (focus)="showCourseDropdown = true"
                            (blur)="hideDropdownWithDelay('COURSE')"
                            formControlName="selectedCourse"
                            placeholder="Select Course"
                            class="w-full border bg-gray-100 border-blue-50 p-2 mb-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <ul
                            *ngIf="showCourseDropdown && filteredCourses?.length > 0"
                            class="absolute z-10 w-full bg-white border border-blue-100 rounded shadow mt-1 max-h-[300px] h-[200px] overflow-y-scroll"
                        >
                            <li
                                *ngFor="let course of filteredCourses"
                                (mousedown)="selectCourse(course)"
                                class="p-2 hover:bg-blue-100 cursor-pointer"
                            >
                                {{ course?.course?.name || 'No Courses' }}
                            </li>
                        </ul>
                    </div>


                    <div class="relative">
                        <input
                            type="text"
                            (keyup)="filterBranch($event.target.value)"
                            (focus)="showBranchDropdown = true"
                            (blur)="hideDropdownWithDelay('BRANCH')"
                            formControlName="selectedBranch"
                            placeholder="Select Branch"
                            class="w-full border bg-gray-100 border-blue-50 p-2 mb-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <ul
                            *ngIf="showBranchDropdown && filteredBranch?.length > 0"
                            class="absolute z-10 w-full bg-white border border-blue-100 rounded shadow mt-1 max-h-[200px] h-[150px] overflow-y-scroll"
                        >
                            <li
                                *ngFor="let branch of filteredBranch"
                                (mousedown)="selectBranch(branch)"
                                class="p-2 hover:bg-blue-100 cursor-pointer"
                            >
                                {{ branch?.branch?.name || 'No Branches' }}
                            </li>
                        </ul>
                    </div>

                    <button
                        type="submit"
                        class="w-full bg-green-600 text-white py-2 rounded font-bold hover:bg-green-700 transition duration-200 ease-in-out"
                        (click)="submit()"
                    >
                        APPLY NOW
                    </button>
                </form>
            </div>
        </div>
    </div>
</section>
<section>
    <div id="medium-screen-banners"
         class="relative w-full  hidden sm:block lg:hidden overflow-hidden aarni-font">
        <img
            *ngFor="let image of mediumScreenBanner; let i = index"
            [src]="image"
            [ngClass]="{
        'opacity-100': currentMediumScreenIndex === i,
        hidden: currentMediumScreenIndex !== i
      }"
            class=" w-full h-full transition-opacity duration-1000 ease-in-out" loading="lazy"
        />

        <div class="bg-white shadow-md p-6 md:p-8 w-full max-w-xl mx-auto mb-6 hidden md:block lg:hidden">
            <div>
                <h3 class="text-lg font-bold mb-4 text-green-600 animate-blink">Admissions Open For 2025</h3>
                <form [formGroup]="applyNowForm">
                    <input
                        type="text"
                        placeholder="Name *"
                        class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        formControlName="name"
                    />
                    <input
                        type="email"
                        placeholder="Email *"
                        class="w-full border p-2 mb-2 rounded bg-gray-100 text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
                        formControlName="email"
                    />
                    <input
                        type="tel"
                        placeholder="Contact *"
                        class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        formControlName="contact"
                    />
                    <select
                        class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
                        formControlName="program_id"
                        (change)="getCourses()"
                    >
                        <option value="">Select Program *</option>
                        <option *ngFor="let program of programs" [value]="program?.program?.id">
                            {{ program?.program?.name }}
                        </option>
                    </select>

                    <div class="relative">
                        <input
                            type="text"
                            (keyup)="filterCourses($event.target.value)"
                            (focus)="showCourseDropdown = true"
                            (blur)="hideDropdownWithDelay('COURSE')"
                            formControlName="selectedCourse"
                            placeholder="Select Course"
                            class="w-full border bg-gray-100 border-blue-50 p-2 mb-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <ul
                            *ngIf="showCourseDropdown && filteredCourses?.length > 0"
                            class="absolute z-10 w-full bg-white border border-blue-100 rounded shadow mt-1 max-h-[300px] h-[200px] overflow-y-scroll"
                        >
                            <li
                                *ngFor="let course of filteredCourses"
                                (mousedown)="selectCourse(course)"
                                class="p-2 hover:bg-blue-100 cursor-pointer"
                            >
                                {{ course?.course?.name || 'No Courses' }}
                            </li>
                        </ul>
                    </div>


                    <div class="relative">
                        <input
                            type="text"
                            (keyup)="filterBranch($event.target.value)"
                            (focus)="showBranchDropdown = true"
                            (blur)="hideDropdownWithDelay('BRANCH')"
                            formControlName="selectedBranch"
                            placeholder="Select Branch"
                            class="w-full border bg-gray-100 border-blue-50 p-2 mb-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <ul
                            *ngIf="showBranchDropdown && filteredBranch?.length > 0"
                            class="absolute z-10 w-full bg-white border border-blue-100 rounded shadow mt-1 max-h-[200px] h-[150px] overflow-y-scroll"
                        >
                            <li
                                *ngFor="let branch of filteredBranch"
                                (mousedown)="selectBranch(branch)"
                                class="p-2 hover:bg-blue-100 cursor-pointer"
                            >
                                {{ branch?.branch?.name || 'No Branches' }}
                            </li>
                        </ul>
                    </div>

                    <button
                        type="submit"
                        class="w-full bg-green-600 text-white py-2 rounded font-bold"
                        (click)="submit()"
                    >
                        APPLY NOW
                    </button>
                    <p class="text-xs text-center mt-2">&#45;&#45;*All Fields are Mandatory&#45;&#45;</p>
                </form>
            </div>
        </div>
    </div>
</section>
<section>
    <div id="mobile-banners" class="relative w-full h-auto sm:hidden overflow-hidden aarni-font mt-[80px]">
        <img
            *ngFor="let image of mobileImages; let i = index"
            [src]="image"
            [ngClass]="{
        'opacity-100': currentMobileIndex === i,
        hidden: currentMobileIndex !== i
      }"
            class="w-full h-auto transition-opacity duration-1000 ease-in-out"
        />
    </div>

    <div class="bg-white shadow-md p-6 md:p-8 w-full max-w-xl mx-auto mb-6 md:hidden">
        <div>
            <h3 class="text-lg font-bold mb-4 text-green-600 animate-blink">Admissions Open For 2025</h3>
            <form [formGroup]="applyNowForm">
                <input
                    type="text"
                    placeholder="Name *"
                    class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    formControlName="name"
                />
                <input
                    type="email"
                    placeholder="Email *"
                    class="w-full border p-2 mb-2 rounded bg-gray-100 text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
                    formControlName="email"
                />
                <input
                    type="tel"
                    placeholder="Contact *"
                    class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    formControlName="contact"
                />
                <select
                    class="w-full border border-blue-50 p-2 mb-2 rounded bg-gray-100 text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
                    formControlName="program_id"
                    (change)="getCourses()"
                >
                    <option value="">Select Program *</option>
                    <option *ngFor="let program of programs" [value]="program?.program?.id">
                        {{ program?.program?.name }}
                    </option>
                </select>

                <div class="relative">
                    <input
                        type="text"
                        (keyup)="filterCourses($event.target.value)"
                        (focus)="showCourseDropdown = true"
                        (blur)="hideDropdownWithDelay('COURSE')"
                        formControlName="selectedCourse"
                        placeholder="Select Course"
                        class="w-full border bg-gray-100 border-blue-50 p-2 mb-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <ul
                        *ngIf="showCourseDropdown && filteredCourses?.length > 0"
                        class="absolute z-10 w-full bg-white border border-blue-100 rounded shadow mt-1 max-h-[300px] h-[200px] overflow-y-scroll"
                    >
                        <li
                            *ngFor="let course of filteredCourses"
                            (mousedown)="selectCourse(course)"
                            class="p-2 hover:bg-blue-100 cursor-pointer"
                        >
                            {{ course?.course?.name || 'No Courses' }}
                        </li>
                    </ul>
                </div>


                <div class="relative">
                    <input
                        type="text"
                        (keyup)="filterBranch($event.target.value)"
                        (focus)="showBranchDropdown = true"
                        (blur)="hideDropdownWithDelay('BRANCH')"
                        formControlName="selectedBranch"
                        placeholder="Select Branch"
                        class="w-full border bg-gray-100 border-blue-50 p-2 mb-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <ul
                        *ngIf="showBranchDropdown && filteredBranch?.length > 0"
                        class="absolute z-10 w-full bg-white border border-blue-100 rounded shadow mt-1 max-h-[200px] h-[150px] overflow-y-scroll"
                    >
                        <li
                            *ngFor="let branch of filteredBranch"
                            (mousedown)="selectBranch(branch)"
                            class="p-2 hover:bg-blue-100 cursor-pointer"
                        >
                            {{ branch?.branch?.name || 'No Branches' }}
                        </li>
                    </ul>
                </div>

                <button
                    type="submit"
                    class="w-full bg-green-600 text-white py-2 rounded font-bold"
                    (click)="submit()"
                >
                    APPLY NOW
                </button>
                <p class="text-xs text-center mt-2">&#45;&#45;*All Fields are Mandatory&#45;&#45;</p>
            </form>
        </div>
    </div>
</section>
<!-- Quick Links Section with Icons -->
<section id="featured-list" class="py-10 bg-white">
    <div class="container mx-auto px-4">
        <div class="flex justify-center">
            <div
                class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 w-full max-w-6xl"
            >
                <!-- Apply Online -->
                <div class="flex flex-col items-center group">
                    <a href="/form/apply-form" class="text-center">
                        <div
                            class="w-28 h-28 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center mb-3 mx-auto transition-all duration-300 group-hover:border-[#5ab11c] group-hover:shadow-lg"
                        >
                            <i class="fa fa-check text-[#ff5757] text-4xl"></i>
                        </div>
                        <h6
                            class="font-semibold uppercase text-[#012E26] text-sm mt-2 group-hover:text-[#5ab11c]"
                        >
                            APPLY ONLINE
                        </h6>
                    </a>
                </div>

                <!-- Schools -->
                <div class="flex flex-col items-center group">
                    <a href="/campus-life/schools" class="text-center">
                        <div
                            class="w-28 h-28 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center mb-3 mx-auto transition-all duration-300 group-hover:border-[#5ab11c] group-hover:shadow-lg"
                        >
                            <i
                                class="fa fa-university text-[#00c3e9] text-4xl"
                            ></i>
                        </div>
                        <h6
                            class="font-semibold uppercase text-[#012E26] text-sm mt-2 group-hover:text-[#5ab11c]"
                        >
                            SCHOOLS
                        </h6>
                    </a>
                </div>

                <!-- Leadership -->
                <div class="flex flex-col items-center group">
                    <a href="/about/leadership/chancellor" class="text-center">
                        <div
                            class="w-28 h-28 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center mb-3 mx-auto transition-all duration-300 group-hover:border-[#5ab11c] group-hover:shadow-lg"
                        >
                            <i class="fa fa-trophy text-[#ff1493] text-4xl"></i>
                        </div>
                        <h6
                            class="font-semibold uppercase text-[#012E26] text-sm mt-2 group-hover:text-[#5ab11c]"
                        >
                            LEADERSHIP
                        </h6>
                    </a>
                </div>

                <!-- Scholarship -->
                <div class="flex flex-col items-center group">
                    <a href="/admissions/scholarship" class="text-center">
                        <div
                            class="w-28 h-28 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center mb-3 mx-auto transition-all duration-300 group-hover:border-[#5ab11c] group-hover:shadow-lg"
                        >
                            <i
                                class="fa fa-graduation-cap text-[#00c070] text-4xl"
                            ></i>
                        </div>
                        <h6
                            class="font-semibold uppercase text-[#012E26] text-sm mt-2 group-hover:text-[#5ab11c]"
                        >
                            SCHOLARSHIP
                        </h6>
                    </a>
                </div>

                <!-- Contact Us -->
                <div class="flex flex-col items-center group">
                    <a href="/quick-links/contact-us" class="text-center">
                        <div
                            class="w-28 h-28 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center mb-3 mx-auto transition-all duration-300 group-hover:border-[#5ab11c] group-hover:shadow-lg"
                        >
                            <i class="fa fa-map-o text-[#ff8c42] text-4xl"></i>
                        </div>
                        <h6
                            class="font-semibold uppercase text-[#012E26] text-sm mt-2 group-hover:text-[#5ab11c]"
                        >
                            CONTACT US
                        </h6>
                    </a>
                </div>

                <!-- Placements -->
                <!--<div class="flex flex-col items-center group">
                    <a href="/placements" class="text-center">
                        <div
                            class="w-28 h-28 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center mb-3 mx-auto transition-all duration-300 group-hover:border-[#5ab11c] group-hover:shadow-lg"
                        >
                            <i
                                class="fa fa-briefcase text-[#5ab11c] text-4xl"
                            ></i>
                        </div>
                        <h6
                            class="font-semibold uppercase text-[#012E26] text-sm mt-2 group-hover:text-[#5ab11c]"
                        >
                            PLACEMENTS
                        </h6>
                    </a>
                </div>-->
            </div>
        </div>
    </div>
</section>
<section id="know-your-program" class="py-10 bg-white aarni-font px-2">
    <div class="container mx-auto">
        <div class="bg-gradient-to-r from-[#04497d] to-[#09709e] text-white p-8 rounded">
            <div class="flex flex-col lg:flex-row items-center justify-between gap-6">
                <div class="w-full lg:w-1/6 text-left">
                    <h2 class="text-lg font-semibold text-yellow-300">Know Your</h2>
                    <h1 class="text-3xl font-bold">Program</h1>
                </div>
                <div class="w-full lg:w-4/6 flex flex-col lg:flex-row gap-4 justify-center">
                    <form [formGroup]="searchForm" class="flex flex-col lg:flex-row gap-4 w-full">
                        <div class="flex flex-col w-full lg:w-80">
                            <label class="text-md font-medium">Select Your Program</label>
                            <select
                                formControlName="program_id"
                                class="mt-1 p-2 text-black rounded w-full"
                                (change)="getFilteredCourses()"
                            >
                                <option value="">Select Course</option>
                                <option *ngFor="let course of externalCourses" [value]="course?.id">
                                    {{ course?.name }}
                                </option>
                            </select>
                        </div>
                        <div class="flex flex-col w-full lg:w-80">
                            <label class="text-md font-medium">Select Your Course</label>
                            <select
                                formControlName="course_id"
                                class="mt-1 p-2 text-black rounded w-full"
                                (change)="getFilteredBranches()"
                            >
                                <option value="">Select Course</option>
                                <option *ngFor="let course of filteredMappingCourses" [value]="course?.id">
                                    {{ course?.name || 'No Branch' }}
                                </option>
                            </select>
                        </div>
                        <div class="flex flex-col w-full lg:w-80">
                            <label class="text-md font-medium">Select Your Specialization</label>
                            <select
                                formControlName="branch_id"
                                class="mt-1 p-2 text-black rounded w-full"
                                (change)="getFilteredBranchData()"
                            >
                                <option value="">Select Branch</option>
                                <option *ngIf="filteredBranches?.length === 0">No Branch</option>
                                <option *ngFor="let branch of filteredBranches" [value]="branch?.branch?.id">
                                    {{ branch?.branch?.name || 'NA' }}
                                </option>
                            </select>
                        </div>
                    </form>
                </div>
                <div class="w-full lg:w-1/6 flex justify-start lg:justify-end">
                    <button
                        (click)="goTo('/form/apply-form')"
                        class="block font-bold text-center transition-all py-3 px-6 rounded-xl whitespace-nowrap border-2 border-white hover:bg-white hover:text-black rounded"
                    >
                        APPLY NOW
                    </button>
                </div>

            </div>
        </div>

        <div *ngIf="selectedBranchData?.course?.name; else noData">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 py-4 bg-white">
                <a [href]="generateSchoolLink()"
                   class="group relative border rounded p-8 hover:shadow-lg transition duration-300 block">
                    <div class="absolute top-4 right-4 w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center
                  opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <i class="fa fa-arrow-right text-white text-md"></i>
                    </div>
                    <h2 class="text-orange-600 font-bold text-xl py-2">{{ selectedBranchData.course?.name }}</h2>
                    <p class="py-1"><span class="text-lg font-bold">Duration:</span> {{ selectedBranchData.duration }}
                        <span *ngIf="selectedBranchData.duration > 1">Years</span>
                        <span *ngIf="selectedBranchData.duration <= 1">Year</span>
                    </p>
                    <p class="py-1"><span class="text-lg font-bold">Level:</span> {{ selectedBranchData.program?.name }}
                    </p>
                    <p class="py-1"><span
                        class="text-lg font-bold">Specialization:</span> {{ selectedBranchData.branch?.name }}</p>
                </a>
                <a [href]="generateSchoolLink()"
                   class="group relative border rounded p-8 flex gap-6 items-start hover:shadow-lg transition duration-300">
                    <div class="absolute top-4 right-4 w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center
                  opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <i class="fa fa-arrow-right text-white text-md"></i>
                    </div>
                    <div class="mt-6 text-[#04497d]">
                        <i class="fa fa-university text-5xl"></i>
                    </div>
                    <div>
                        <h3 class="font-bold text-xl mt-4">{{ selectedBranchData.school?.name }}</h3>
                        <p class="text-orange-500 text-lg font-bold py-2">Established in: <strong>2009</strong></p>
                        <p class="text-lg py-2" *ngIf="selectedBranchData?.tuitionfee > 0">Fees :
                            &#8377; {{ selectedBranchData?.tuitionfee | IndianNumber }}</p>
                        <p class="text-lg py-2" *ngIf="selectedBranchData?.tuitionfee <= 0">Fees : - </p>
                        <p class="text-lg py-2">{{ selectedBranchData.department?.tagline || '' }}</p>

                    </div>
                </a>
                <a [href]="generateSchoolLink()"
                   class="group relative border rounded p-8 flex gap-6 items-start hover:shadow-lg transition duration-300">
                    <div class="absolute top-4 right-4 w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center
                  opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <i class="fa fa-arrow-right text-white text-md"></i>
                    </div>
                    <img
                        [src]="getDeanDetails().image"
                        [alt]="getDeanDetails().name"
                        class="w-28 h-28 object-cover mt-4" loading="lazy"
                    />
                    <div>
                        <p class="text-orange-600 font-bold text-xl mt-6">{{ getDeanDetails().name }}</p>
                        <p class="text-lg py-4">{{ getDeanDetails().designation }}</p>
                    </div>
                </a>
            </div>
        </div>
        <ng-template #noData>
            <div class="bg-white p-12 border rounded text-center my-4 text-red-600 font-semibold text-lg">
                No data To Show!
            </div>
        </ng-template>
    </div>
</section>
<!-- Campus Information Section with Carousels -->
<section id="campus-short-info" class="py-8 font-montserrat">
    <div class="container-fluid mx-auto px-4">
        <div class="flex flex-wrap -mx-4 overflow-hidden">
            <!-- Main Banner Carousel - Left Large Column (8/12) -->
            <div class="w-full md:w-8/12 mb-8 md:mb-0">
                <div
                    id="main-carousel"
                    class="relative h-full overflow-hidden shadow-md"
                >
                    <!-- Carousel Images -->
                    <div class="relative h-full">
                        <img
                            *ngFor="
                                let image of mainCarouselImages;
                                let i = index
                            "
                            [src]="image"
                            [ngClass]="{
                                'opacity-100 z-10': carouselIndex === i,
                                'opacity-0 absolute inset-0':
                                    carouselIndex !== i
                            }"
                            alt="Banner image" loading="lazy"
                            class="w-full h-full object-cover transition-opacity duration-500 ease-in-out"
                        />
                        <!-- Navigation Controls -->
                        <button
                            (click)="prevCarousel()"
                            class="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/70 rounded-full w-10 h-10 flex items-center justify-center text-gray-800 hover:bg-white hover:text-[#5ab11c] z-20"
                        >
                            <i class="fa fa-chevron-left"></i>
                        </button>
                        <button
                            (click)="nextCarousel()"
                            class="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/70 rounded-full w-10 h-10 flex items-center justify-center text-gray-800 hover:bg-white hover:text-[#5ab11c] z-20"
                        >
                            <i class="fa fa-chevron-right"></i>
                        </button>
                        <!-- Dots Indicators -->
                        <div
                            class="absolute bottom-4 left-0 right-0 flex justify-center space-x-2 z-20"
                        >
                            <button
                                *ngFor="
                                    let image of mainCarouselImages;
                                    let i = index
                                "
                                (click)="setCarousel(i)"
                                [ngClass]="{
                                    'bg-white': mainCarouselIndex === i,
                                    'bg-white/50': mainCarouselIndex !== i
                                }"
                                class="w-3 h-3 rounded-full transition-all duration-300"
                            ></button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- News Events Carousel - Right Small Column (4/12) -->

            <div class="w-full md:w-4/12 mb-8 md:mb-0">
                <div
                    id="events-carousel"
                    class="relative h-full overflow-hidden shadow-md"
                >
                    <div
                        *ngFor="let event of eventsData; let i = index"
                        [ngClass]="{
                'opacity-100 z-10': eventsCarouselIndex === i,
                'opacity-0 absolute inset-0': eventsCarouselIndex !== i
            }"
                        class="transition-opacity duration-500 ease-in-out h-full"
                    >
                        <div class="h-full w-full overflow-hidden">
                            <img
                                [src]="event.image"
                                [alt]="event.title"
                                class="w-full h-full object-cover" loading="lazy"
                            />
                        </div>
                    </div>

                    <!-- Dots Indicators -->
                    <div class="absolute bottom-4 right-4 flex space-x-2 z-20">
                        <button
                            *ngFor="let event of eventsData; let i = index"
                            (click)="setEventsCarousel(i)"
                            [ngClass]="{
                    'bg-gray-800': eventsCarouselIndex === i,
                    'bg-gray-300': eventsCarouselIndex !== i
                }"
                            class="w-2 h-2 rounded-full transition-all duration-300"
                        ></button>
                    </div>
                </div>
            </div>


            <!--  <div class="w-full md:w-4/12  mb-8 md:mb-0">
                  <div
                      id="events-carousel"
                      class="relative h-auto overflow-hidden shadow-md"
                  >
                      &lt;!&ndash; Event Image &ndash;&gt;
                      <div
                          *ngFor="let event of eventsData; let i = index"
                          [ngClass]="{
                              'opacity-100 z-10': eventsCarouselIndex === i,
                              'opacity-0 absolute inset-0':
                                  eventsCarouselIndex !== i
                          }"
                          class="transition-opacity duration-500 ease-in-out"
                      >
                          <div class="h-full w-full overflow-hidden">
                              <img
                                  [src]="event.image"
                                  [alt]="event.title"
                                  class="w-full h-full object-cover"
                              />
                          </div>
                          &lt;!&ndash; Event Content &ndash;&gt;
                        &lt;!&ndash;  <div class="p-4 bg-white">
                              <div class="flex items-start">
                                  <div
                                      class="bg-[#f58634] text-white text-center px-4 py-2 rounded-lg mr-4 w-[20%]"
                                  >
                                      <div class="text-xl font-bold">
                                          {{ event.date.split(" ")[0] }}
                                      </div>
                                      <div class="text-sm">
                                          {{ event.date.split(" ")[1] }}
                                          {{ event.date.split(" ")[2] }}
                                      </div>
                                  </div>
                                  <h5
                                      class="text-[#012E26] font-semibold text-lg w-[80%]"
                                  >
                                      <a href="#" class="hover:text-[#5ab11c]">{{
                                              event.title
                                          }}</a>
                                  </h5>
                              </div>
                          </div>&ndash;&gt;
                      </div>

                      &lt;!&ndash; Dots Indicators &ndash;&gt;
                      <div class="absolute bottom-4 right-4 flex space-x-2 z-20">
                          <button
                              *ngFor="let event of eventsData; let i = index"
                              (click)="setEventsCarousel(i)"
                              [ngClass]="{
                                  'bg-gray-800': eventsCarouselIndex === i,
                                  'bg-gray-300': eventsCarouselIndex !== i
                              }"
                              class="w-2 h-2 rounded-full transition-all duration-300"
                          ></button>
                      </div>
                  </div>
              </div>-->

            <!-- Bottom Row - Three Columns -->
            <div class="w-full">
                <div class="flex flex-wrap -mx-4">
                    <!-- Research Banner 1 -->
                    <div class="w-full md:w-4/12 mb-4 md:mb-0">
                        <div
                            class="h-full overflow-hidden shadow-md bottom-row-banner"
                        >
                            <img
                                src="assets/img/Alumnies/top-faculty-members.jpg"
                                alt="Faculty Research"
                                class="w-full h-full object-cover"
                                loading="lazy"
                            />
                        </div>
                    </div>

                    <!-- NBA Accreditation Banner -->
                    <div class="w-full md:w-4/12 mb-4 md:mb-0">
                        <div
                            class="h-full overflow-hidden shadow-md bottom-row-banner"
                        >
                            <img
                                src="assets/img/building_knowledge_through_experimentation.webp"
                                alt="NBA Accreditation"
                                class="w-full h-full object-cover"
                                loading="lazy"
                            />
                        </div>
                    </div>

                    <!-- Launchpad Banner -->
                    <div class="w-full md:w-4/12">
                        <div
                            class="h-full w-full overflow-hidden shadow-md relative bottom-row-banner"
                        >
                            <img
                                src="assets/img/placement-image.jpg"
                                alt="Placements"
                                class="w-full h-full object-cover"
                                loading="lazy"
                            />
                            <!--<div
                                class="absolute inset-0 bg-black/30 flex items-center justify-center"
                            >
                                <div class="text-white text-center">
                                    <h3 class="text-2xl font-bold">
                                        AARNI LAUNCHPAD
                                    </h3>
                                    <p class="text-sm mt-2">
                                        Your entrepreneurial dream begins here!
                                    </p>
                                </div>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- University Impact Section -->

<section id="" class="py-16 bg-gray-100 font-montserrat overflow-x-hidden block lg:hidden">
    <div class="container mx-auto px-4">
        <div class="flex flex-wrap items-center">
            <!-- Left Side - Impact Graphic -->
            <div class="w-full md:w-1/2 px-4 mb-12 md:mb-0 flex justify-center relative overflow-visible">
                <div class="impact-circle relative w-[320px]  h-[320px] sm:w-[350px] sm:h-[350px]">
                    <!-- Large Circular Progress -->
                    <div class="progress-ring absolute inset-0 rounded-full border-[6px] border-[#00BFA5]"></div>

                    <!-- Inner Circle -->
                    <div
                        class="inner-circle absolute inset-10 rounded-full bg-white border-[3px] border-gray-300"></div>

                    <!-- Center Text -->
                    <div
                        class="center-text absolute inset-0 flex items-center justify-center cursor-pointer"
                        (click)="setSelectedImpactStat('programmes')"
                    >
                        <div class="circular-center text-center">
                            <h2
                                class="text-3xl font-bold"
                                [ngClass]="{
                  'text-[#00BFA5]': selectedImpactStat === 'programmes',
                  'text-gray-800': selectedImpactStat !== 'programmes'
                }"
                            >
                                200<span class="text-[#00BFA5]">+</span>
                            </h2>
                        </div>
                    </div>

                    <!-- Stats Around the Circle -->
                    <div
                        class="stat-item absolute left-1/2 transform -translate-x-1/2 top-[10px]"
                    >
                        <h3
                            class="text-2xl font-bold cursor-pointer hover:text-[#00BFA5] transition-colors"
                            (click)="setSelectedImpactStat('countries')"
                            [ngClass]="{
                'text-[#00BFA5]': selectedImpactStat === 'countries'
              }"
                        >
                            120+
                        </h3>
                    </div>

                    <div
                        class="stat-item absolute top-[80px] left-[15px] sm:top-[170px] sm:left-[40px]"
                    >
                        <h3
                            class="text-2xl font-bold cursor-pointer hover:text-[#00BFA5] transition-colors"
                            (click)="setSelectedImpactStat('students')"
                            [ngClass]="{
                'text-[#00BFA5]': selectedImpactStat === 'students'
              }"
                        >
                            11000+
                        </h3>
                    </div>

                    <div
                        class="stat-item absolute top-[80px] right-[15px] sm:top-[170px] sm:right-[40px]"
                    >
                        <h3
                            class="text-2xl font-bold cursor-pointer hover:text-[#00BFA5] transition-colors"
                            (click)="setSelectedImpactStat('sports')"
                            [ngClass]="{
                'text-[#00BFA5]': selectedImpactStat === 'sports'
              }"
                        >
                            20+
                        </h3>
                    </div>

                    <div
                        class="stat-item absolute bottom-[70px] left-[20px] sm:bottom-[110px] sm:left-[50px]"
                    >
                        <h3
                            class="text-2xl font-bold cursor-pointer hover:text-[#00BFA5] transition-colors"
                            (click)="setSelectedImpactStat('faculty')"
                            [ngClass]="{
                'text-[#00BFA5]': selectedImpactStat === 'faculty'
              }"
                        >
                            500+
                        </h3>
                    </div>

                    <div
                        class="stat-item absolute bottom-[70px] right-[20px] sm:bottom-[110px] sm:right-[50px]"
                    >
                        <h3
                            class="text-2xl font-bold cursor-pointer hover:text-[#00BFA5] transition-colors"
                            (click)="setSelectedImpactStat('collaboration')"
                            [ngClass]="{
                'text-[#00BFA5]': selectedImpactStat === 'collaboration'
              }"
                        >
                            95+
                        </h3>
                    </div>
                </div>
            </div>

            <div class="w-full md:w-1/2 px-4 title-section">
                <h2 class="text-2xl font-extrabold text-center md:text-left">ARNI IMPACT</h2>
                <div class="mt-8 impact-content">
                    <div class="fade-in">
                        <h3 class="text-xl font-semibold">{{ getSelectedImpactStat().number }}</h3>
                        <h4 class="text-lg mt-1">{{ getSelectedImpactStat().title }}</h4>
                        <p class="mt-2 text-gray-700 text-justify">{{ getSelectedImpactStat().description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="impact" class="py-16 bg-gray-100 font-montserrat hidden lg:block">
    <div class="container mx-auto px-4">
        <div class="flex flex-wrap items-center">
            <div class="w-full md:w-1/2 px-4 mb-12 md:mb-0">
                <div class="impact-circle">
                    <div class="progress-ring"></div>
                    <div class="inner-circle"></div>
                    <div
                        class="stat-item absolute"
                        style="
                            top: 30px;
                            left: 50%;
                            transform: translateX(-50%);
                        "
                    >
                        <h3
                            class="text-2xl font-bold cursor-pointer hover:text-[#00BFA5] transition-colors"
                            (click)="setSelectedImpactStat('countries')"
                            [ngClass]="{
                                'text-[#00BFA5]':
                                    selectedImpactStat === 'countries'
                            }"
                        >
                            120+
                        </h3>
                    </div>

                    <div
                        class="stat-item absolute top-[80px] left-[40px] sm:top-[170px] sm:left-[70px]"
                    >
                        <h3
                            class="text-2xl font-bold cursor-pointer hover:text-[#00BFA5] transition-colors"
                            (click)="setSelectedImpactStat('students')"
                            [ngClass]="{
                                'text-[#00BFA5]':
                                    selectedImpactStat === 'students'
                            }"
                        >
                            11000+
                        </h3>
                    </div>

                    <div
                        class="stat-item absolute top-[80px] right-[40px] sm:top-[170px] sm:right-[70px]"
                    >
                        <h3
                            class="text-2xl font-bold cursor-pointer hover:text-[#00BFA5] transition-colors"
                            (click)="setSelectedImpactStat('sports')"
                            [ngClass]="{
                                'text-[#00BFA5]':
                                    selectedImpactStat === 'sports'
                            }"
                        >
                            20+
                        </h3>
                    </div>

                    <div
                        class="stat-item absolute bottom-[70px] left-[50px] sm:bottom-[110px] sm:left-[90px]"
                    >
                        <h3
                            class="text-2xl font-bold cursor-pointer hover:text-[#00BFA5] transition-colors"
                            (click)="setSelectedImpactStat('faculty')"
                            [ngClass]="{
                                'text-[#00BFA5]':
                                    selectedImpactStat === 'faculty'
                            }"
                        >
                            500+
                        </h3>
                    </div>

                    <div
                        class="stat-item absolute bottom-[70px] right-[50px] sm:bottom-[110px] sm:right-[90px]"
                    >
                        <h3
                            class="text-2xl font-bold cursor-pointer hover:text-[#00BFA5] transition-colors"
                            (click)="setSelectedImpactStat('collaboration')"
                            [ngClass]="{
                                'text-[#00BFA5]':
                                    selectedImpactStat === 'collaboration'
                            }"
                        >
                            95+
                        </h3>
                    </div>

                    <div
                        class="center-text cursor-pointer"
                        (click)="setSelectedImpactStat('programmes')"
                    >
                        <div class="circular-center">
                            <h2
                                [ngClass]="{
                                    'text-[#00BFA5]':
                                        selectedImpactStat === 'programmes',
                                    'text-gray-800':
                                        selectedImpactStat !== 'programmes'
                                }"
                            >
                                200<span class="text-[#00BFA5]">+</span>
                            </h2>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full md:w-1/2 px-4 title-section">
                <h2 class="font-bolder text-xl text-nowrap">ARNI IMPACT</h2>
                <div class="mt-8 impact-content">
                    <div class="fade-in">
                        <h3>{{ getSelectedImpactStat().number }}</h3>
                        <h4>{{ getSelectedImpactStat().title }}</h4>
                        <p class="text-justify">
                            {{ getSelectedImpactStat().description }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Featured Section with Tabs -->
<section id="featured-section" class="py-10 bg-white font-montserrat">
    <div class="container mx-auto px-4">
        <!-- Tabs Navigation -->
        <div class="flex flex-col sm:flex-col md:flex-row justify-center items-center mb-8 border-b">
            <button
                (click)="setActiveTab('faculties')"
                class="w-full md:w-auto px-6 py-3 text-lg font-medium text-center transition-all duration-300"
                [ngClass]="{
        'border-b-2 border-[#00BFA5] text-[#012E26]': activeTab === 'faculties',
        'text-gray-500 hover:text-gray-700': activeTab !== 'faculties'
    }"
            >
                Top Leadership
            </button>
            <button
                (click)="setActiveTab('awards')"
                class="w-full md:w-auto px-6 py-3 text-lg font-medium text-center transition-all duration-300"
                [ngClass]="{
        'border-b-2 border-[#00BFA5] text-[#012E26]': activeTab === 'awards',
        'text-gray-500 hover:text-gray-700': activeTab !== 'awards'
    }"
            >
                Awards & Achievements
            </button>
            <button
                (click)="setActiveTab('stories')"
                class="w-full md:w-auto px-6 py-3 text-lg font-medium text-center transition-all duration-300"
                [ngClass]="{
        'border-b-2 border-[#00BFA5] text-[#012E26]': activeTab === 'stories',
        'text-gray-500 hover:text-gray-700': activeTab !== 'stories'
    }"
            >
                Success Stories
            </button>
        </div>

        <div class="relative">
            <div *ngIf="activeTab === 'faculties'" class="animate-fade-in">
                <div class="flex justify-center relative">
                    <!--  <button
                          class="hidden md:flex absolute left-0 top-1/2 transform -translate-y-1/2 bg-white rounded-full w-12 h-12 items-center justify-center shadow-md z-10 text-gray-700 hover:text-[#00BFA5]"
                      >
                          <i class="fa fa-chevron-left text-xl"></i>
                      </button>-->

                    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 w-full">
                        <div
                            class="faculty-card w-full bg-white shadow-md rounded-lg overflow-hidden h-full flex flex-col">
                            <div class="p-6 flex flex-col items-center">
                                <div class="w-32 h-32 rounded-full overflow-hidden border-4 border-gray-200 mb-4">
                                    <img src="assets/img/top-leadership/chancellor-arni.jpg" alt="Dr. Vivek Singh"
                                         loading="lazy"
                                         class="w-full h-full object-cover"/>
                                </div>
                                <h3 class="text-lg font-bold text-center">Dr. Vivek Singh</h3>
                                <p class="text-sm text-gray-600 text-center mt-2">Chancellor, ARNI UNIVERSITY</p>
                                <p class="mt-2 text-center">Dr. Vivek Singh, the Chancellor of the ARNI University, is a
                                    leading educational reformer who has transformed teaching methodology across India
                                    with his dedication and hard work.</p>
                            </div>
                            <a href="about/leadership/chancellor"
                               class="mb-6 mx-auto flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-[#00BFA5] text-gray-600 hover:text-white transition-all duration-300">
                                <i class="fa fa-arrow-right"></i>
                            </a>
                        </div>

                        <div
                            class="faculty-card w-full bg-white shadow-md rounded-lg overflow-hidden h-full flex flex-col">
                            <div class="p-6 flex flex-col items-center">
                                <div class="w-32 h-32 rounded-full overflow-hidden border-4 border-gray-200 mb-4">
                                    <img src="assets/img/top-leadership/vice-chancellor-arni.jpg" loading="lazy"
                                         alt="Prof.(Dr.) R.K. Pandey" class="w-full h-full object-cover"/>
                                </div>
                                <h3 class="text-lg font-bold text-center">Prof.(Dr.) R.K. Pandey</h3>
                                <p class="text-sm text-gray-600 text-center mt-2">Vice Chancellor, ARNI UNIVERSITY</p>
                                <p class="mt-2 text-center">Prof. (Dr.) R.K. Pandey is a distinguished academic leader
                                    with extensive experience in engineering education. He serves as the Vice Chancellor
                                    of ARNI University in Himachal Pradesh.</p>
                            </div>
                            <a href="about/leadership/vice-chancellor"
                               class="mb-6 mx-auto flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-[#00BFA5] text-gray-600 hover:text-white transition-all duration-300">
                                <i class="fa fa-arrow-right"></i>
                            </a>
                        </div>

                        <div
                            class="faculty-card w-full bg-white shadow-md rounded-lg overflow-hidden h-full flex flex-col">
                            <div class="p-6 flex flex-col items-center">
                                <div class="w-32 h-32 rounded-full overflow-hidden border-4 border-gray-200 mb-4">
                                    <img src="assets/img/top-leadership/pro-vice-chancellor-arni.jpg" loading="lazy"
                                         alt="Prof. (Dr.) Manish Kumar Srivastava" class="w-full h-full object-cover"/>
                                </div>
                                <h3 class="text-lg font-bold text-center">Prof. (Dr.) Manish Kumar Srivastava</h3>
                                <p class="text-sm text-gray-600 text-center mt-2">Pro Vice Chancellor, ARNI
                                    UNIVERSITY</p>
                                <p class="mt-2 text-center">Prof. (Dr.) Manish Kumar Srivastava has a background in
                                    education from Lucknow. Dr. Manish appreciates persistence, curiosity, and
                                    adaptability and is excited to help ARNI University grow.</p>
                            </div>
                            <a href="about/leadership/pro-vice-chancellor"
                               class="mb-6 mx-auto flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-[#00BFA5] text-gray-600 hover:text-white transition-all duration-300">
                                <i class="fa fa-arrow-right"></i>
                            </a>
                        </div>

                        <div
                            class="faculty-card w-full bg-white shadow-md rounded-lg overflow-hidden h-full flex flex-col">
                            <div class="p-6 flex flex-col items-center">
                                <div class="w-32 h-32 rounded-full overflow-hidden border-4 border-gray-200 mb-4">
                                    <img src="assets/img/top-leadership/registrar-arni.jpg" alt="Dr.Trilochan Singh"
                                         loading="lazy"
                                         class="w-full h-full object-cover"/>
                                </div>
                                <h3 class="text-lg font-bold text-center">Dr. Trilochan Singh</h3>
                                <p class="text-sm text-gray-600 text-center mt-2">Registrar, ARNI UNIVERSITY</p>
                                <p class="mt-2 text-center">Dr. Trilochan Singh serves as the Registrar at Arni
                                    University, Himachal Pradesh. In this capacity, he plays a pivotal role in the
                                    university's administration and academic coordination.</p>
                            </div>
                            <a href="about/leadership/registrar"
                               class="mb-6 mx-auto flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-[#00BFA5] text-gray-600 hover:text-white transition-all duration-300">
                                <i class="fa fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>

                    <!--   <button
                           class="hidden md:flex absolute right-0 top-1/2 transform -translate-y-1/2 bg-white rounded-full w-12 h-12 items-center justify-center shadow-md z-10 text-gray-700 hover:text-[#00BFA5]"
                       >
                           <i class="fa fa-chevron-right text-xl"></i>
                       </button>-->
                </div>

                <div class="flex justify-center mt-8">
                    <a
                        href="/about/faculty"
                        class="py-2 px-6 bg-white rounded border border-[#00BFA5] text-[#00BFA5] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium"
                    >
                        View all
                    </a>
                </div>
            </div>

            <div *ngIf="activeTab === 'awards'" class="animate-fade-in">
                <div class="flex justify-center relative">
                    <!--   <button
                           class="hidden md:flex absolute left-0 top-1/2 transform -translate-y-1/2 bg-white rounded-full w-12 h-12 items-center justify-center shadow-md z-10 text-gray-700 hover:text-[#00BFA5]"
                       >
                           <i class="fa fa-chevron-left text-xl"></i>
                       </button>-->

                    <div
                        class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 w-full"
                    >
                        <div
                            class="award-card bg-white shadow-md rounded-lg overflow-hidden"
                        >
                            <div class="h-48 overflow-hidden">
                                <img
                                    src="assets/img/awards-achievments/3.webp"
                                    alt="Green University Award"
                                    class="w-full h-full object-cover" loading="lazy"
                                />
                            </div>
                            <div class="p-4">
                                <h3 class="text-lg font-bold">
                                    Green University Award: 2022
                                </h3>
                            </div>
                        </div>

                        <div
                            class="award-card bg-white shadow-md rounded-lg overflow-hidden"
                        >
                            <div class="h-48 overflow-hidden">
                                <img
                                    src="assets/img/awards-achievments/1.webp"
                                    alt="Himachal Ratan"
                                    class="w-full h-full object-cover"
                                    loading="lazy"
                                />
                            </div>
                            <div class="p-4">
                                <h3 class="text-lg font-bold">
                                    Himachal Ratan Award
                                </h3>
                            </div>
                        </div>

                        <div
                            class="award-card bg-white shadow-md rounded-lg overflow-hidden"
                        >
                            <div class="h-48 overflow-hidden">
                                <img
                                    src="assets/img/awards-achievments/4.webp"
                                    alt=" Certificate of Excellence by Dainik Jagran"
                                    class="w-full h-full object-cover"
                                    loading="lazy"
                                />
                            </div>
                            <div class="p-4">
                                <h3 class="text-lg font-bold">
                                    Certificate of Excellence by Dainik Jagran
                                </h3>
                            </div>
                        </div>

                        <div
                            class="award-card bg-white shadow-md rounded-lg overflow-hidden"
                        >
                            <div class="h-48 overflow-hidden">
                                <img
                                    src="assets/img/awards-achievments/2.webp"
                                    alt="Certificate of Appreciation"
                                    class="w-full h-full object-cover"
                                    loading="lazy"
                                />
                            </div>
                            <div class="p-4">
                                <h3 class="text-lg font-bold">
                                    Certificate of Appreciation
                                </h3>
                            </div>
                        </div>
                    </div>

                    <!--     <button
                             class="hidden md:flex absolute right-0 top-1/2 transform -translate-y-1/2 bg-white rounded-full w-12 h-12 items-center justify-center shadow-md z-10 text-gray-700 hover:text-[#00BFA5]"
                         >
                             <i class="fa fa-chevron-right text-xl"></i>
                         </button>-->
                </div>

                <!-- View All Button -->
                <!--  <div class="flex justify-center mt-8">
                      <a
                          href="/awards"
                          class="py-2 px-6 bg-white rounded-full border border-[#00BFA5] text-[#00BFA5] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium"
                      >
                          View all Awards
                      </a>
                  </div>-->
            </div>

            <div *ngIf="activeTab === 'stories'" class="animate-fade-in">
                <div class="flex justify-center relative">
                    <!--   <button
                           class="hidden md:flex absolute left-0 top-1/2 transform -translate-y-1/2 bg-white rounded-full w-12 h-12 items-center justify-center shadow-md z-10 text-gray-700 hover:text-[#00BFA5]"
                       >
                           <i class="fa fa-chevron-left text-xl"></i>
                       </button>-->

                    <div
                        class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 w-full"
                    >
                        <div
                            class="story-card bg-white shadow-md rounded-lg overflow-hidden h-full"
                        >
                            <div class="overflow-hidden">
                                <img
                                    src="assets/img/success-story/abhishek-bhatia.webp"
                                    alt="Abhishek Bhatia"
                                    class="w-full h-auto object-cover"
                                    loading="lazy"
                                />
                            </div>
                            <div class="p-4">
                                <h3 class="text-lg font-bold">
                                    Abhishek Bhatia(B.Tech – Civil), Assistant Engineer, Jal Shakti Vibhag, Sub Division
                                    Nagrota Bhawan, Distt. Kangra
                                </h3>
                                <p
                                    class="text-sm text-gray-600 mt-2 line-clamp-3 text-justify"
                                >
                                    We all say that ARNI is on a mission to serve the nation. Abhishek Bhatia’s career
                                    path and success reflect our dedication to producing skilled professionals who serve
                                    the nation. His role as an Assistant Engineer in the Jal Shakti Vibhag is a proud
                                    achievement, contributing to critical water infrastructure in Himachal Pradesh.
                                </p>
                            </div>
                        </div>

                        <div
                            class="story-card bg-white shadow-md rounded-lg overflow-hidden h-full"
                        >
                            <div class="overflow-hidden">
                                <img
                                    src="assets/img/success-story/barun-sharma.webp"
                                    alt="Barun Sharma"
                                    class="w-full h-auto object-cover"
                                    loading="lazy"
                                />
                            </div>
                            <div class="p-4">
                                <h3 class="text-lg font-bold">
                                    Barun Sharma(B-Tech Mechanical Engineer), Public Works Department, Junior Assistant
                                    Jammu
                                </h3>
                                <p
                                    class="text-sm text-gray-600 mt-2 line-clamp-3 text-justify"
                                >
                                    Barun's journey is a testament to hard work and determination. With a strong
                                    foundation built at ARNI University, Barun cleared competitive examinations and
                                    secured a government role in the Public Works Department. His dedication to public
                                    service and technical excellence makes us immensely proud.

                                </p>
                            </div>
                        </div>

                        <div
                            class="story-card bg-white shadow-md rounded-lg overflow-hidden h-full"
                        >
                            <div class="overflow-hidden">
                                <img
                                    src="assets/img/success-story/waseem-akram.webp"
                                    alt="Waseem Akram"
                                    class="w-full h-auto object-cover"
                                />
                            </div>
                            <div class="p-4">
                                <h3 class="text-lg font-bold">
                                    Waseem Akaram (M-Tech in Civil), Technical officer at Shree Cement Ltd.
                                </h3>
                                <p
                                    class="text-sm text-gray-600 mt-2 line-clamp-3 text-justify"
                                >
                                    Waseem always had a passion for building things that last. At ARNI, he gained not
                                    only academic strength but also real-world insights that helped him land a key
                                    technical role at one of India's leading cement companies. His growth from student
                                    to professional reflects the university's commitment to career-driven education.
                                </p>
                            </div>
                        </div>

                        <div
                            class="story-card bg-white shadow-md rounded-lg overflow-hidden h-full"
                        >
                            <div class="overflow-hidden">
                                <img
                                    src="assets/img/success-story/pradeep-singh.webp"
                                    alt="Pradeep Singh"
                                    class="w-full h-auto object-cover"
                                />
                            </div>
                            <div class="p-4">
                                <h3 class="text-lg font-bold">
                                    Pradeep Singh(B-Tech Mechanical), IIT Jammu, Mechanical Engineer
                                </h3>
                                <p
                                    class="text-sm text-gray-600 mt-2 line-clamp-3 text-justify"
                                >
                                    From ARNI classrooms to one of India’s top institutions—IIT Jammu, Pradeep’s journey
                                    showcases what determination and the right guidance can achieve. At ARNI, he
                                    developed critical thinking, practical skills, and the confidence to reach greater
                                    heights.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- <button
                         class="hidden md:flex absolute right-0 top-1/2 transform -translate-y-1/2 bg-white rounded-full w-12 h-12 items-center justify-center shadow-md z-10 text-gray-700 hover:text-[#00BFA5]"
                     >
                         <i class="fa fa-chevron-right text-xl"></i>
                     </button>-->
                </div>

                <!-- View All Button -->
                <div class="flex justify-center mt-8">
                    <a
                        href="/alumni/connect"
                        class="py-2 px-6 bg-white rounded border border-[#00BFA5] text-[#00BFA5] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium"
                    >
                        View all
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- What's Happening in AARNI Section -->

<div id="whats-happening" class="w-full">
    <div class="bg-gradient-to-b from-blue-500 to-blue-300 py-12">
        <div class="container mx-auto px-6 w-full">
            <h2 class="text-white text-2xl font-bold text-center mb-6">WHAT’S HAPPENING IN SCHOOL</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div
                    *ngFor="let event of events"
                    class="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer relative"
                    (click)="openEventModal(event)"
                >
                    <img
                        [src]="event.image"
                        [alt]="event.title"
                        class="w-full h-56 object-cover"
                        style="transition: none; transform: none;"
                    />
                    <div class="p-4">
            <span
                class="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full absolute -mt-8"
            >
              Event
            </span>
                        <h3 class="text-lg font-semibold mt-2">{{ event.title }}</h3>
                        <p class="text-sm text-gray-600 mt-2">{{ event.description }}</p>
                    </div>
                </div>
            </div>
            <div class="flex justify-center mt-10">
                <a
                    href="/whats-happening/event-calendar"
                    class="py-3 px-8 rounded bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md"
                >
                    View More
                </a>
            </div>
            <div
                *ngIf="selectedEvent"
                class="fixed inset-0 z-50 top-16 flex items-center justify-center bg-black bg-opacity-50 p-4"
            >
                <div class="bg-white rounded-lg max-w-xl w-full p-6 relative shadow-xl overflow-y-auto max-h-[70vh] md:max-h-[90vh]">
                    <button
                        (click)="closeModal()"
                        class="absolute top-2 right-2 text-gray-600 hover:text-black text-2xl"
                    >
                        &times;
                    </button>
                    <div *ngIf="selectedEvent?.instaLink" class="w-full flex justify-center px-2">
                        <div class="w-full max-w-[340px] md:max-w-[420px] max-h-[70vh] xl:max-h-full overflow-y-auto">
                            <blockquote
                                class="instagram-media w-full"
                                [attr.data-instgrm-permalink]="selectedEvent.instaLink"
                                data-instgrm-version="14"
                                style="background:#FFF; border:0; margin: 1rem auto; width: 100%;"
                            ></blockquote>
                        </div>
                    </div>
                    <img *ngIf="!selectedEvent?.instaLink"
                         [src]="selectedEvent.image"
                         [alt]="selectedEvent.title"
                         class="w-full h-64 object-cover rounded-md mb-4"
                         style="transition: none; transform: none;"
                    />
                    <h3 *ngIf="!selectedEvent?.instaLink" class="text-xl font-semibold mb-2">{{ selectedEvent.title }}</h3>
                    <p *ngIf="!selectedEvent?.instaLink" class="text-sm text-gray-700">{{ selectedEvent.description }}</p>
                </div>
            </div>
        </div>
    </div>
</div>

<section id="announcements" class="py-12 bg-white font-montserrat">
    <div class="container mx-auto px-4">
        <div class="flex justify-between items-center mb-8">
            <h2 class="text-2xl font-semibold text-[#012E26]">ANNOUNCEMENTS</h2>
            <div class="flex space-x-2">
                <button
                    (click)="prevAnnouncementPage()"
                    class="w-10 h-10 rounded-full border border-[#00BFA5] flex items-center justify-center text-[#00BFA5] hover:bg-[#00BFA5] hover:text-white transition-all"
                >
                    <i class="fa fa-chevron-left"></i>
                </button>
                <button
                    (click)="nextAnnouncementPage()"
                    class="w-10 h-10 rounded-full border border-[#00BFA5] flex items-center justify-center text-[#00BFA5] hover:bg-[#00BFA5] hover:text-white transition-all"
                >
                    <i class="fa fa-chevron-right"></i>
                </button>
            </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div
                *ngFor="let announcement of getCurrentAnnouncements(); let i = index"
                class="border overflow-hidden hover:shadow-md transition-all duration-300"
            >
                <a
                    [href]="announcement.link"
                    [attr.target]="i === 0 ? '_blank' : null"
                    class="block"
                >
                    <img
                        *ngIf="announcement.image"
                        [src]="announcement.image"
                        [alt]="announcement.title"
                        class="w-full h-full object-cover"
                    />

                    <div class="flex p-4 gap-4">
                        <div class="flex-shrink-0">
                            <div
                                [ngClass]="announcement.color"
                                class="text-white rounded-lg text-center py-1 px-4 w-24"
                            >
                                <div class="text-sm font-bold">
                                    {{ announcement.date.split(" ")[0] }}
                                    {{ announcement.date.split(" ")[1] }}
                                </div>
                                <div class="text-xs">
                                    {{ announcement.date.split(" ")[2] }}
                                </div>
                            </div>
                        </div>
                        <div>
                            <h3 class="text-sm font-semibold text-[#012E26] hover:text-[#00BFA5]">
                                {{ announcement.title }}
                            </h3>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
    <div class="flex justify-center mt-10">
        <a
            href="/quick-links/announcements"
            class="py-3 px-8 rounded bg-blue-100 text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md"
        >
            View More
        </a>
    </div>
</section>

<section id="events" class="py-12 px-3 md:px-0 bg-[#EFFFE8]">
    <h2 class="text-2xl sm:text-3xl font-bold text-center">
        Ignite the Spark: Where Ideas Meet Celebration
    </h2>
    <p class="text-center max-w-3xl mx-auto text-gray-600 mb-6 px-4">
        A dynamic blend of creativity, culture, and innovation — where passion meets purpose and every moment sparks
        inspiration and celebration.
    </p>

    <div class="relative w-full max-w-5xl xl:max-w-6xl mx-auto overflow-hidden rounded shadow-lg">
        <div class="w-full h-[700px] relative transition-all duration-500"
             *ngIf="eventCarouselImages.length > 0">
            <img
                [src]="eventCarouselImages[currentEventsImageIndex].url"
                alt="Slide"
                class="w-full h-full object-cover"
            />
            <div
                class="absolute bottom-0 left-0 right-0 bg-gray-100 p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <div>
                    <h3 class="font-bold text-lg">{{ eventCarouselImages[currentEventsImageIndex].title }}</h3>
                    <p class="text-sm text-gray-700">
                        {{ eventCarouselImages[currentEventsImageIndex].description }}
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="flex justify-center gap-2 mt-4">
        <div *ngFor="let img of eventCarouselImages; let i = index"
             class="h-1 w-6 rounded-full cursor-pointer transition-all duration-300"
             [ngClass]="{'bg-[#00BFA5]': i === currentEventsImageIndex, 'bg-gray-300': i !== currentEventsImageIndex}"
             (click)="currentEventsImageIndex = i">
        </div>
    </div>

    <div class="flex justify-center mt-10">
        <a href="/quick-links/image-gallery"
           class="py-3 px-8 rounded bg-white text-[#00BFA5] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md border border-[#00BFA5]">
            View More
        </a>
    </div>
</section>

<!-- Testimonials Section -->
<div id="section7" class="py-16 bg-white font-montserrat">
    <div class="container mx-auto px-4 text-center">
        <h2 class="text-4xl font-bold text-[#012E26] mb-12">Testimonials</h2>
        <div class="testimonial-slider relative">
            <div class="overflow-hidden px-2">
                <div
                    class="flex transition-transform duration-500 ease-in-out"
                    [ngStyle]="{
            transform: 'translateX(' + -testimonialSlideIndex * 100 + '%)'
          }"
                >
                    <ng-container *ngFor="let group of groupedTestimonials">
                        <div class="w-full flex-shrink-0 flex pb-4">
                            <div
                                *ngFor="let testimonial of group"
                                class="w-full md:1/2 lg:w-1/3 px-3"
                            >
                                <div
                                    class="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl h-full">
                                    <div class="bg-[#ff6347] h-32 rounded-t-lg relative">
                                        <div
                                            class="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2"
                                        >
                                            <div class="w-24 h-24 rounded-full bg-white p-1">
                                                <img
                                                    [src]="testimonial.image"
                                                    [alt]="testimonial.name"
                                                    class="w-full h-full rounded-full object-cover"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-16 pb-8 px-6">
                                        <h3
                                            class="text-xl font-semibold text-center text-[#012E26] mb-2"
                                        >
                                            {{ testimonial.name }}
                                        </h3>
                                        <div class="flex justify-center mb-4">
                                            <i
                                                class="fa fa-star text-yellow-400"
                                                *ngFor="let star of [1, 2, 3, 4, 5]"
                                            ></i>
                                        </div>
                                        <p class="text-gray-700 text-center mb-6 text-justify">
                                            {{ testimonial.feedback }}
                                        </p>
                                        <div class="text-center text-sm text-gray-600">
                                            <p class="font-semibold">{{ testimonial.course }}</p>
                                            <p class="font-bold text-[#012E26]"
                                               *ngIf="testimonial && testimonial.name != 'Vinit Gupta' && testimonial.name != 'Geetika Katoch' && testimonial.name != 'Harshal Singh Thakur'">
                                                Placed As:
                                                <span class="text-[#00BFA5]">
                          {{ testimonial.designation }}
                        </span>
                                            </p>
                                            <p class="font-bold text-[#012E26]"
                                               *ngIf="testimonial && testimonial.name === 'Vinit Gupta'">
                                                Owner:
                                                <span class="text-[#00BFA5]">
                          {{ testimonial.designation }}
                        </span>
                                            </p>
                                            <p class="font-bold text-[#012E26] "
                                               *ngIf="testimonial && (testimonial.name === 'Geetika Katoch' || testimonial.name === 'Harshal Singh Thakur')">
                                                Placed In:
                                                <span class="text-[#00BFA5]">
                          {{ testimonial.designation }}
                        </span>
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="flex justify-center mt-8 space-x-2">
                <button
                    *ngFor="let group of groupedTestimonials; let i = index"
                    [ngClass]="{
            'bg-[#00BFA5]': testimonialSlideIndex === i,
            'bg-gray-300': testimonialSlideIndex !== i
          }"
                    class="w-3 h-3 rounded-full transition-all duration-300"
                    (click)="setTestimonialSlide(i)"
                ></button>
            </div>
        </div>

        <div class="flex justify-center mt-10">
            <a
                href="/quick-links/student-testimonial"
                class="py-3 px-8 rounded bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md border border-[#00BFA5]"
            >
                View More
            </a>
        </div>
    </div>
</div>

<!--<section
    id="event"
    class="pt-16 aarni-font"
    *ngIf="studentLifeImages && studentLifeImages.length"
>
    <h2
        class="text-4xl font-bold text-[#012E26] mb-4 text-center"
        style="margin-top: 50px"
    >
        Student's Life
    </h2>

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2">
        <ng-container *ngFor="let img of studentLifeImages.slice(0, 3); let i = index">
            <div
                class="relative group cursor-pointer overflow-hidden shadow h-60"
                (click)="openImage(i)"
            >
                <img
                    [src]="img"
                    alt="Student Life"
                    class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div
                    class="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                    <i class="fas fa-search text-white text-3xl"></i>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 py-2">
        <ng-container *ngFor="let img of studentLifeImages.slice(3, 5); let i = index">
            <div
                class="relative group cursor-pointer overflow-hidden shadow h-60"
                (click)="openImage(i + 3)"
            >
                <img
                    [src]="img"
                    alt="Student Life"
                    class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div
                    class="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                    <i class="fas fa-search text-white text-3xl"></i>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2">
        <ng-container *ngFor="let img of studentLifeImages.slice(5, 9); let i = index">
            <div
                class="relative group cursor-pointer overflow-hidden shadow h-60"
                (click)="openImage(i + 5)"
            >
                <img
                    [src]="img"
                    alt="Student Life"
                    class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div
                    class="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                    <i class="fas fa-search text-white text-3xl"></i>
                </div>
            </div>
        </ng-container>
    </div>

    <div
        *ngIf="currentImageIndex !== null"
        class="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50"
        (click)="closeImage()"
    >
        <button
            class="absolute top-4 right-4 text-white text-4xl z-50 bg-black bg-opacity-50 rounded-full px-3 hover:bg-opacity-70 transition"
            (click)="closeImage(); $event.stopPropagation()"
        >
            &times;
        </button>

        <button
            class="absolute left-4 text-white text-3xl"
            (click)="prevImage(); $event.stopPropagation()"
        >
            &#8592;
        </button>

        <img
            [src]="studentLifeImages[currentImageIndex!]"
            class="max-h-[80vh] max-w-[90vw] object-contain"
            (click)="$event.stopPropagation()"
        />

        <button
            class="absolute right-4 text-white text-3xl"
            (click)="nextImage(); $event.stopPropagation()"
        >
            &#8594;
        </button>
    </div>
</section>-->

<!-- Companies Hiring Section -->
<section id="company-hiring" class="section hidden lg:block">
    <div class="container-fluid">
        <h2
            class="text-4xl font-bold text-[#012E26] mb-12"
            style="margin-top: 50px"
        >
            Companies Hiring
        </h2>
        <p class="lead md:mb-[100px]" style="margin-top: 50px">
            Top companies are hiring from ARNI
        </p>
        <div class="stats-bg clearfix hidden md:block">
            <div class="animate">
                <ul class="clearfix">
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/hcl.png"
                            alt="logo"
                            src="assets/img/companies/hcl.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/syntel2.png"
                            alt="logo"
                            src="assets/img/companies/syntel2.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/amarujala.png"
                            alt="logo"
                            src="assets/img/companies/amarujala.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/Vodafone_logo.png"
                            alt="logo"
                            src="assets/img/companies/Vodafone_logo.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/cmc-logo_0.png"
                            alt="logo"
                            src="assets/img/companies/cmc-logo_0.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/FutureGroup.png"
                            alt="logo"
                            src="assets/img/companies/FutureGroup.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/sleepwell.png"
                            alt="logo"
                            src="assets/img/companies/sleepwell.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/Tech_Mahindra_New_Logo1.png"
                            alt="logo"
                            src="assets/img/companies/Tech_Mahindra_New_Logo1.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/Amazon.png"
                            alt="logo"
                            src="assets/img/companies/Amazon.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/zenpact.png"
                            alt="logo"
                            src="assets/img/companies/zenpact.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/adani_wilmar.png"
                            alt="logo"
                            src="assets/img/companies/adani_wilmar.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/Dish_TV_2.png"
                            alt="logo"
                            src="assets/img/companies/Dish_TV_2.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/niit_logo_03.png"
                            alt="logo"
                            src="assets/img/companies/niit_logo_03.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/icici_securities.png"
                            alt="logo"
                            src="assets/img/companies/icici_securities.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/Zee_TV_2011.png"
                            alt="logo"
                            src="assets/img/companies/Zee_TV_2011.png"
                        />
                    </li>
                    <li>
                        <img
                            class="company-rotating-logo"
                            data-src="assets/img/companies/Zee_TV_2011.png"
                            alt="logo"
                            src="assets/img/companies/Zee_TV_2011.png"
                        />
                    </li>
                </ul>
            </div>
            <div class="round round1">
                <span class="sm-round"></span>
                <div class="content">
                    <figure>
                        <img
                            class=""
                            data-src="assets/img/companies/icon2.png"
                            alt="icon"
                            src="assets/img/companies/icon2.png"
                        />
                    </figure>
                    <h4>65% to 100%</h4>
                    <p>Placement program wise</p>
                    <!--<h4>Upto 100%</h4>
                    <p>Placement Assistance</p>-->
                </div>
            </div>
            <div class="round round2">
                <span class="sm-round"></span>
                <div class="content">
                    <figure>
                        <img
                            class=""
                            data-src="assets/img/companies/icon3.png"
                            alt="icon"
                            src="assets/img/companies/icon3.png"
                        />
                    </figure>
                    <h4>26000+</h4>

                    <p>Successful Alumni worldwide</p>
                </div>
            </div>
            <div class="round round3">
                <span class="sm-round"></span>
                <div class="content">
                    <figure>
                        <img
                            class=""
                            data-src="assets/img/companies/icon1.png"
                            alt="icon"
                            src="assets/img/companies/icon1.png"
                        />
                    </figure>
                    <h4>600+</h4>

                    <p>companies hiring world wide</p>
                </div>
            </div>
        </div>

        <!-- Mobile Screen-->
        <div class="hidden">
            <div class="relative">
                <div
                    class="w-[350px] h-[350px] rounded-full relative animate-rotate top-[160px] left-[50%] translate-x-[-50%] border-dashed border border-gray-300"
                >
                    <div
                        class="bg-white border flex items-center justify-center w-[35px] h-[35px] rounded-full absolute top-[160px] left-[-10px] static-img"
                    >
                        <img src="assets/img/companies/hcl.png" alt="logo"/>
                    </div>
                    <div
                        class="bg-white border flex items-center justify-center w-[35px] h-[35px] rounded-full absolute top-[160px] right-[-10px] static-img"
                    >
                        <img
                            src="assets/img/companies/Zee_TV_2011.png"
                            alt="logo"
                        />
                    </div>
                    <div
                        class="bg-white border flex items-center justify-center w-[35px] h-[35px] rounded-full absolute top-[-18px] left-[157px] static-img"
                    >
                        <img
                            src="assets/img/companies/icici_securities.png"
                            alt="logo"
                        />
                    </div>
                    <div
                        class="bg-white border flex items-center justify-center w-[35px] h-[35px] rounded-full absolute bottom-[-18px] left-[157px] static-img"
                    >
                        <img
                            src="assets/img/companies/niit_logo_03.png"
                            alt="logo"
                        />
                    </div>
                </div>
                <div
                    class="w-[280px] h-[290px] rounded-full border border-dashed border-gray-300 absolute left-[50%] top-[200px] translate-x-[-50%]"
                ></div>
                <div
                    class="w-[200px] h-[220px] rounded-full border border-dashed border-gray-300 left-[50%] translate-x-[-50%] top-[240px] absolute bottom-0"
                ></div>
                <div
                    class="w-[110px] h-[120px] z-[2000] border border-dashed border-gray-300 rounded-full absolute left-[50%] top-[290px] translate-x-[-50%] bottom-0"
                ></div>
            </div>
        </div>
    </div>
</section>
